/**
 * Created by Ding on 12/04/2017.
 */

import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';
import { Tabs } from 'antd';

const TabPane = Tabs.TabPane;


export default class HunterTabs extends Component {
    static propTypes = {
        location: PropTypes.object.isRequired,
        children: PropTypes.object.isRequired,
    };

    constructor(props) {
        super(props);
        this.state = {
            activeKey: props.location.pathname.indexOf('positions') > -1 ? '1' : '2',
        };
    }

    componentWillReceiveProps(newProps) {
        this.setState({
            activeKey: newProps.location.pathname.indexOf('positions') > -1 ? '1' : '2',
        });
    }

    render() {
        return (
            <div>
                <Tabs activeKey={this.state.activeKey}>
                    <TabPane tab={<Link to="/positions">需求职位</Link>} key="1" />
                    <TabPane tab={<Link to="/candidates">候选人</Link>} key="2" />
                </Tabs>

                {this.props.children}
            </div>
        );
    }
}

HunterTabs.propTypes = {};
